###
  @deprecated: use INTENT.utils.Tooltip instead
  Tooltip widget
###

class INTENT.widgets.Tooltip

  @ATTR_NAME: "data-widget-tooltip"

  @SELECTOR_MODAL: "#modal_container"

  constructor: (@el) ->
    @s = @.constructor

    @el.tooltip @get_options()

  get_options: () ->
    {
      'animation': true,
      'placement': 'top',
      'html': true,
      'container': $('body')
    }